import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';
import { ReactiveFormsModule } from '@angular/forms';

import { PillarModule } from '../pillar/pillar.module'
import { reducers } from './store/reducers';
import { routes } from './routes.config';
import { DashboardTilesRegistry } from '../pillar/dashboard/services/DashboardTilesRegistry';

import { ModuleConfiguration } from './dynamicDataSet.module.config';
import { CoreModule } from '../core/core.module';
import { DynamicDataSetTileComponent } from './components/dynamic-dataset-tile.component';
import { AddDynamicDataSetDialogComponent } from './components/add-dynamic-dataset-dialog.component';
import { DeleteDynamicDataSetConfirmationDialogComponent } from './components/delete-dynamic-dataset-confirmation-dialog.component';
import { DynamicDataSetWorkspaceComponent } from './components/dynamic-dataset-workspace.component';
import { ConfigurationDashboardComponent } from '../configuration/components/configuration-dashboard.component';
import { DynamicDataSetService } from './service/DynamicDataSetService';
import { DynamicDataSetServiceEffects } from './service/DynamicDataSetService.effects';
import { DynamicRuleWorkspaceComponent } from './components/dynamic-rule-workspace.component';

@NgModule({
  entryComponents: [DynamicDataSetTileComponent, AddDynamicDataSetDialogComponent, DeleteDynamicDataSetConfirmationDialogComponent, DynamicDataSetWorkspaceComponent, DynamicRuleWorkspaceComponent],
  declarations: [DynamicDataSetTileComponent, AddDynamicDataSetDialogComponent, DeleteDynamicDataSetConfirmationDialogComponent, DynamicDataSetWorkspaceComponent, DynamicRuleWorkspaceComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forFeature(ModuleConfiguration.moduleName, reducers),
    EffectsModule.forFeature([DynamicDataSetServiceEffects]),
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    PillarModule,
    FileUploadModule,
    CoreModule
  ],
  exports: [],
  providers: [DynamicDataSetService]
})
export class DynamicDataSetsModule {
  constructor(private dashboardTilesRegistry: DashboardTilesRegistry) {
    dashboardTilesRegistry.registerTile(ConfigurationDashboardComponent.dashboardName,
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 3,
        tileComponent: DynamicDataSetTileComponent,
        permission: "DynamicDataSetModule.DynamicDataSets:View",
        displayName: "Dynamic Data Sets"
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/dynamicDataSet.module.ts